var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoadingGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9984 4C7.57917 4 3.99671 7.58246 3.99671 12.0016C3.99671 16.4208 7.57917 20.0033 11.9984 20.0033C16.4175 20.0033 20 16.4208 20 12.0016C20 7.58246 16.4175 4 11.9984 4ZM1.99671 12.0016C1.99671 6.47789 6.4746 2 11.9984 2C17.5221 2 22 6.47789 22 12.0016C22 17.5254 17.5221 22.0033 11.9984 22.0033C6.4746 22.0033 1.99671 17.5254 1.99671 12.0016Z",
    fill: "url(#paint0_linear_4376_5137)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4376_5137",
    x1: 2.52311,
    y1: 13.5575,
    x2: 21.4736,
    y2: 13.5575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CD617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1CD617",
    stopOpacity: 0.08
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingGreen);
export default __webpack_public_path__ + "static/media/loading_green.8819becc319711db36ffba590c2de4b0.svg";
export { ForwardRef as ReactComponent };